<template>
	<div>
		<div class="sf-search-layout__body__container">
			<sf-search-layout>
				<el-row :gutter="20">
					<el-col :span="4">
						<select-combo
							:label="getMessage_('QWCC000984')"
							paramKey="plntCd"
							:options="plntList"
							@commChange="setSearchParam"
							disabled
						></select-combo>
					</el-col>
					<el-col :span="4">
						<select-combo
							:label="getMessage_('MWCC000688')"
							paramKey="powCd"
							:options="powList"
							@commChange="setSearchParam"
						></select-combo>
					</el-col>
				</el-row>
				<template slot="button">
					<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
						{{ getButtonMsg_(scrId, 'CR') }}
					</sf-button>
				</template>
			</sf-search-layout>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SelectCombo from '@qms/Components/SelectCombo';
export default {
	props: { scrId: { type: String, default: '' } },
	components: { SelectCombo },
	async created() {
		try {
			await this.getCommCodes_({ key: 'plntList', codeType: 'FACTORY_CD' });
			await this.getCommCodes_({ key: 'powList', codeType: 'POW' });
			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message || error
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		async searchList() {
			this.$sf_toggleLoading(true);
			this.getPowAttrList_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
			// try {
			// 	this.$sf_toggleLoading(true);
			// 	this.getPowAttrList_();
			// } catch (error) {
			// 	this.$sf_toast({
			// 		type: 'error',
			// 		message: error.message || error
			// 	});
			// } finally {
			// 	this.$sf_toggleLoading(false);
			// }
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
